import { HttpClient } from "@angular/common/http"
import { Injectable, inject } from "@angular/core"
import { Observable, shareReplay } from "rxjs"
import { Category, PagedCategory, CreateCategory, ModifyObject } from "../models"
import { environment } from "src/environments/environment"

@Injectable({
    providedIn: "root",
})
export class CategoryService {
    private _http = inject(HttpClient)
    private _apiUrl = environment.apiBaseUrl + environment.endpointRoutes.categories

    Get(): Observable<Category[]> {
        return this._http.get<Category[]>(this.AllUrl())
    }
    AllUrl(): string {
        return this._apiUrl
    }

    private _all$: Observable<Category[]> | undefined

    GetAllCached(): Observable<Category[]> {
        this._all$ ??= this.Get().pipe(shareReplay({ bufferSize: 1, refCount: false }))
        return this._all$
    }

    GetByMasterId(masterId: string): Observable<Category> {
        return this._http.get<Category>(this.ByMasterIdUrl(masterId))
    }
    ByMasterIdUrl(masterId: string): string {
        return `${this._apiUrl}/${masterId}`
    }

    GetLookup(type: string, search: string, skip: number, take: number, isActive?: boolean): Observable<PagedCategory> {
        const httpParams: Record<string, string> = {
            skip: skip.toString(),
            take: take.toString(),
        }
        if (type) httpParams["type"] = type
        if (search) httpParams["search"] = search
        if (isActive !== undefined) httpParams["isActive"] = isActive.toString()

        return this._http.get<PagedCategory>(this._apiUrl + "/lookup", { params: httpParams })
    }

    Create(createCategory: CreateCategory): Observable<Category> {
        return this._http.post<Category>(this._apiUrl, createCategory)
    }

    Modify(masterId: string, data: ModifyObject): Observable<Category> {
        return this._http.patch<Category>(this.ByMasterIdUrl(masterId), data)
    }

    Delete(masterId: string): Observable<string> {
        return this._http.delete<string>(this.ByMasterIdUrl(masterId))
    }
}
